import { useCallback } from 'react';
import { useClientContext } from 'client/context';
import { setPairs } from 'ducks/pairs/slices';
import { updateSettings } from 'ducks/settings/slices';
import { useAppDispatch } from 'store/hooks';

const usePricesApi = () => {
  const dispatch = useAppDispatch();
  const { Voladeum, handleError } = useClientContext();

  const getData = useCallback(async () => {
    try {
      dispatch(updateSettings({ loading: true }));

      const [voladeum_pairs] = await Promise.all([Voladeum.pairs.list()]);

      dispatch(setPairs(voladeum_pairs.data));
      dispatch(updateSettings({ loading: false }));
    } catch (err) {
      handleError(err);
    }
  }, [dispatch, Voladeum, handleError]);

  return { getData };
};

export { usePricesApi };
